<template>
<div id="">

  <v-card class="mt-4" >
    <v-hover v-slot:default="{ hover }">
      <v-sheet class="v-sheet--offset mx-auto" :color="color" :elevation="hover ? 12 : 2" max-width="calc(100% - 32px)">
        <v-sparkline smooth :labels="labels" :value="values" :show-labels="true" color="white" line-width="3" padding="16" label-size="10"></v-sparkline>
      </v-sheet>
    </v-hover>

    <v-card-text class="pt-0">
      <div class="title font-weight-light mb-2">{{label}}</div>
      <div class="subheading font-weight-light grey--text"></div>
      <v-divider class="my-2"></v-divider>
      <v-icon class="mr-2" small>
        fa-clock
      </v-icon>
      <span class="caption grey--text font-weight-light">last registration 26 minutes ago</span>
    </v-card-text>
  </v-card>

</div>
</template>
<script>
export default {
  name: "",
  props: ['label', 'labels', 'values', 'color'],
  data: () => ({

  })
}
</script>
<style lang="scss" scoped>
.v-sheet--offset {
    top: -24px;
    position: relative;
}
</style>
